module.exports = function() {
  return new Worker(__webpack_public_path__ + "8b39eb9dcd801767796e.worker.js");
};